<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('view')}} {{ $t('vendormapping') }}</div>
      <div>
        <router-link
          class="btn-blue"
          :to="'/fnb/edit-vendor-mapping?vendor_id='+vendor_id+'&rmv_id='+rmv_id"
        >{{ $t('edit') }}</router-link>
        <router-link
          class="btn-blue"
          to="/fnb/vendor-mapping"
        >{{ $tc('vendor', 1) }} {{ $tc('list', 2) }}</router-link>
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div class="row">
          <!-- <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('cinema', 1) }} {{ $t('name') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ viewVendorObject.cine_name }}</div>
            </div>
          </div>-->

          <div class="col-md-12 py-2 border-bottom">
            <ul class="list-inline raw-mat-list font-weight-bold">
              <li class="list-inline-item">{{ $tc('rawmaterials', 2) }}</li>
              <li class="list-inline-item ml-5">QTY</li>
              <li class="list-inline-item ml-5">UOM</li>
              <li class="list-inline-item ml-5">Price</li>
            </ul>
            <ul
              v-for="(RawMaterial, RawMaterialIndex) in viewVendorRawMaterial"
              :key="RawMaterialIndex"
              class="list-inline raw-mat-list"
            >
              <li class="list-inline-item">{{ RawMaterial.name }}</li>
              <li class="list-inline-item ml-5">{{ RawMaterial.quantity }}</li>
              <li class="list-inline-item ml-5">{{ RawMaterial.uom }}</li>
              <li class="list-inline-item ml-5">{{ RawMaterial.price }}</li>
            </ul>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('vendor', 1) }} {{ $t('name') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ viewVendorObject.v_name }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('status', 1) }}</div>
              <div
                class="col-md-9 col-lg-10 col-xl-10"
              >{{ viewVendorObject.rmv_is_active | activeParse }}</div>
            </div>
          </div>

          <div class="col-12" v-if=" GetRoleId && GetRoleId === 1 ">
            <div class="row">
              <div class="col-md-12 py-2 border-bottom">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdby') }}</div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span>{{ viewVendorObject.created_by }}</span>
                  </div>
                </div>
              </div>

              <div class="col-md-12 py-2 border-bottom">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdat') }}</div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span class="mr-3">{{ viewVendorObject.created_at | dateparse }}</span>
                    <!-- <span>12:05 AM</span> -->
                  </div>
                </div>
              </div>

              <div class="col-md-12 py-2 border-bottom">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('modifiedby') }}</div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span>{{ viewVendorObject.updated_by }}</span>
                  </div>
                </div>
              </div>

              <div class="col-md-12 py-2">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('modifiedat') }}</div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span class="mr-3">{{ viewVendorObject.updated_at | dateparse }}</span>
                    <!-- <span>12:05 AM</span> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";

export default {
  data() {
    return {
      // SAIF
      viewVendorObject: {
        cine_name: null,
        cine_id: null,
        rmv_is_active: null,
        v_name: null,
        v_id: null,
        created_by: null,
        created_at: null,
        updated_by: null,
        updated_at: null
      },
      viewVendorRawMaterial: [],

      // SAIF END

      UomList: "",
      rmv_is_active: true,
      rmv_is_default_vendor: true,
      vendor_id: "",
      cinema_id: "",
      rmv_id: "",
      SelectedVendor: "",
      selectedCinema: "",
      created_by: "",
      created_at: "",
      updated_by: "",
      updated_at: "",
      selectVendorOptions: ["India", "UAE", "USA", "UK", "China", "Sri Lanka"],
      Cinemas: [],
      Vendors: [],
      RawMaterials: [],
      selectedRawMaterial: {
        name: null,
        rm_id: null,
        rmv_id: null,
        vr_id: null,
        vr_qty: null,
        vr_rate: null,
        vr_is_active: null,
        uom_unit: null
      },
      selectedRawMaterials: [
        {
          name: "",
          rm_id: ""
        }
      ]
    };
  },
  async mounted() {
    await this.getRawMaterials();
  },
  beforeMount() {
    this.vendor_id = this.$route.query.vendor_id;
    this.rmv_id = this.$route.query.rmv_id;
  },
  methods: {
    getMappingDetails: function() {
      this.viewVendorRawMaterial = [];
      // let payload = {
      //   tableName: "ln_raw_material_vendors",
      //   vendor_id: this.vendor_id
      // };
      // MasterService.GetVendorMappingDetails(payload)
      let payload = {
        vendor_id: this.vendor_id
      };
      PosFnbService.GetVendorMappingDetails(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            // this.Cinemas = data.Records;
            this.viewVendorObject = {
              ...data.Records[0],
              cine_id: data.Records[0].cinema_id
            };
            let obj = data.Records[0];
            this.getViewUsersDetails(obj["created_by"] || null, "created_by");
            this.getViewUsersDetails(obj["created_by"] || null, "updated_by");
            this.getCinemasList(obj.cinema_id);
            this.getVendorsList(obj.vendor_id);

            data.Records.map((x, index) => {
              let array = this.RawMaterials.filter(
                y => y.rm_id === x.rawmaterial_id
              );
              if (array.length > 0) {
                let obj = {
                  name: array[0].rm_name,
                  rm_id: x.rm_id,
                  rmv_id: x.rmv_id,
                  quantity: x.vr_qty,
                  uom: null,
                  uom_id: x.uom_id,
                  price: x.vr_rate
                };
                this.getunitsofmeasurements1(obj, index);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getViewUsersDetails(user_id, fieldvalue) {
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this[fieldvalue] = data.Records[0].user_name;
              this.viewVendorObject[fieldvalue] = data.Records[0].user_name;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      }
    },
    getCinemasList: function(cinema_id) {
      let payload = {
        tableName: "ms_cinemas",
        cine_is_active: "Y",
        cine_id: cinema_id
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.selectedCinema = data.Records[0].cine_name;
            this.viewVendorObject.cine_name = data.Records[0].cine_name || null;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getVendorsList: function(vendor_id) {
      let payload = {
        tableName: "ms_vendors",
        v_is_active: "Y",
        v_id: vendor_id
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.viewVendorObject.v_name = data.Records[0].v_name;
            this.viewVendorObject.v_id = data.Records[0].v_id;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getRawMaterials: function(rm_id, rmv_id, index) {
      // console.log("rmv_id", rmv_id);
      let loader = this.$loading.show();

      let payload = {
        tableName: "ms_raw_materials",
        rm_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.RawMaterials = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(async () => {
          await this.getMappingDetails();
          setTimeout(() => loader.hide(), 1100);
        });
    },

    getunitsofmeasurements1: function(obj) {
      let payload = {
        tableName: "ms_unit_of_measurement",
        uom_is_active: "Y",
        uom_id: obj.uom_id
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            // this.UomList = data.Records;
            this.viewVendorRawMaterial.push({
              ...obj,
              uom: data.Records[0].uom_unit
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getCinemasList1: function(cinema_id) {
      let payload = {
        tableName: "ms_cinemas",
        cine_is_active: "Y",
        cine_id: cinema_id
      };
      // console.log("payload :", payload);
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          // console.log("data :", data);
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.selectedCinema = data.Records[0].cine_name;
            // console.log("this.selectedCinema", this.selectedCinema);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getVendorsList1: function(vendor_id) {
      let payload = {
        tableName: "ms_vendors",
        v_is_active: "Y",
        v_id: vendor_id
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Vendors = data.Records;
            this.SelectedVendor = data.Records[0].v_name;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },

    onFinalSubmit: function() {
      let payload = {
        cinema_id: this.cinema_id,
        vendor_id: this.vendor_id,
        rmv_id: this.rmv_id,
        rmv_is_default_vendor: this.rmv_is_default_vendor == true ? "Y" : "N",
        rmv_is_active: this.rmv_is_active == true ? "Y" : "N",
        selectedRawMaterials: this.selectedRawMaterials
      };
      PosFnbService.UpdateVendorMapping(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    }
  }
};
</script>

<style>
.raw-mat-list li {
  min-width: 50px;
  text-align: center;
}
.raw-mat-list li:nth-child(1) {
  min-width: 250px;
  text-align: left;
}
</style>




// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/VendorsMappingComponents/viewVendorMapping.vue